module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AdminUsers container-fluid"
  }, [_c('Navigation', {
    attrs: {
      "showPromoterNav": "true"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table userTable"
  }, [_c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      class: {
        unconfirmed: !user.confirmed
      }
    }, [_c('td', [_vm._v(_vm._s(user.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), (user.type !== 'promoter') ? _c('td', [_vm._v(_vm._s(user.firstName))]) : _vm._e(), _vm._v(" "), (user.type === 'promoter') ? _c('td', [(typeof user.promoter !== 'undefined') ? _c('span', [_vm._v(" " + _vm._s(user.promoter.data.companyName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (user.type !== 'promoter') ? _c('td', [_vm._v(_vm._s(user.lastName))]) : _vm._e(), _vm._v(" "), (user.type === 'promoter') ? _c('td', [(typeof user.promoter !== 'undefined') ? _c('span', [_vm._v(" " + _vm._s(user.promoter.data.rnaatNumber))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [(!user.approved) ? _c('button', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          _vm.approveUser({
            id: user.id,
            approved: true
          })
        }
      }
    }, [_vm._v("aprovar")]) : _vm._e(), _vm._v(" "), (user.approved) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.approveUser({
            id: user.id,
            approved: false
          })
        }
      }
    }, [_vm._v("desaprovar")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          _vm.loginAs(user.username)
        }
      }
    }, [_vm._v("login")])])])
  }))])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6cfb5bba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cfb5bba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminUsers.vue
// module id = 787
// module chunks = 3